import React, { FC, useMemo } from 'react';
import { Text, StyleSheet } from 'react-native';
import { isPhone, isWeb } from '@helpers';
import { NCLineProps, NCTokenType } from '@components/common/NCFile/types';
import { TOKEN_COLOR_MAP } from '@components/common/NCFile/constants/ncFileViewer.constants';

const NCLine: FC<NCLineProps> = ({ C, line, paddingHorizontal, scale, ncFileTextColor, singleColor, ncFileContentFontConfig }) => {
  const fontStyle = useMemo(() => ncFileContentFontConfig
    ? {
        fontSize: ncFileContentFontConfig.fontSize,
        lineHeight: ncFileContentFontConfig.lineHeight,
        fontWeight: ncFileContentFontConfig.fontWeight as any,
        letterSpacing: ncFileContentFontConfig.letterSpacing,
        fontFamily: ncFileContentFontConfig.fontFamily,
      }
    : {
        fontSize: scale(isPhone ? 12 : 16),
        lineHeight: scale(isPhone ? 25 : 29),
        fontWeight: '400' as const,
        letterSpacing: scale(isPhone ? 0.15 : 0.3),
        fontFamily: isWeb ? "'Roboto Mono', monospace" : 'RobotoMono',
      }, [scale, ncFileContentFontConfig]);

  const getTokenColor = (type: NCTokenType): string => {
    if (singleColor && ncFileTextColor) {
      return ncFileTextColor;
    }
    return C(TOKEN_COLOR_MAP[type]);
  };

  const rowHeight = fontStyle.lineHeight;

  return (
    <Text style={[fontStyle, styles.lineText, { paddingHorizontal: scale(paddingHorizontal) }, !isWeb && { height: rowHeight }]} numberOfLines={1}>
      {line.tokens.map((token, index) => {
        const isLast = index === line.tokens.length - 1;
        const trailingSpace = isLast || token.noTrailingSpace ? '' : ' ';
        return (
          <Text key={`${line.key}-t${index}`} style={{ color: getTokenColor(token.type) }}>
            {token.value}{trailingSpace}
          </Text>
        );
      })}
    </Text>
  );
};

const styles = StyleSheet.create({
  lineText: {
    flexShrink: 0,
  },
});

export default React.memo(NCLine, (prev, next) => prev.line.key === next.line.key && prev.C.scheme === next.C.scheme && prev.singleColor === next.singleColor && prev.ncFileTextColor === next.ncFileTextColor);
